import { HTTPError } from '../../error';

export enum ProductPriceType {
  FREE = 'free',
  CUSTOM = 'custom',
  FROM_STRIPE = 'from_stripe',
}

export const stringToProductPriceType = (price?: string) => {
  const priceType = price as ProductPriceType;
  if (!priceType) {
    throw HTTPError.typeError('Could not parse price to ProductPriceType');
  }
  return priceType;
};

export default ProductPriceType;
